import type { IEnergyPassportDetailsCell } from "@/features/energy-passport/ui/detail-tables/model/types.ts"

export const energyPassportDetailsCommonCells: IEnergyPassportDetailsCell[] = [
  "declared_consumption",
  "sub_consumption",
  "total_consumption",
  "technical_needs",
  "own_needs",
  "production_needs",
  "residential_needs",
  "consumption_standard"
]
